const DAY = 24 * 60 * 60 * 1000;

function startOfDay(date: Date): number {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  ).getTime();
}

function daysAgo(date: Date): number {
  return Math.round((startOfDay(new Date()) - startOfDay(date)) / DAY);
}

export function clockTime(date: Date, use24hTimeFormat: boolean): string {
  return date.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    hour12: !use24hTimeFormat,
  });
}

// Conversation list: "9:41 AM", "Yesterday", "Tuesday" or "2026-10-03"
export function listTime(date: Date, use24hTimeFormat: boolean): string {
  const days = daysAgo(date);
  if (days <= 0) {
    return clockTime(date, use24hTimeFormat);
  }
  if (days === 1) {
    return "Yesterday";
  }
  if (days < 7) {
    return date.toLocaleDateString([], { weekday: "long" });
  }
  return date.toLocaleDateString([], {
    year: "2-digit",
    month: "numeric",
    day: "numeric",
  });
}

// Centered label in a chat: ["Today", "9:41 AM"], ["Tue, Oct 7", "9:41 AM"]
export function chatTimestamp(
  date: Date,
  use24hTimeFormat: boolean
): [string, string] {
  const days = daysAgo(date);
  let day: string;
  if (days <= 0) {
    day = "Today";
  } else if (days === 1) {
    day = "Yesterday";
  } else if (days < 7) {
    day = date.toLocaleDateString([], { weekday: "long" });
  } else {
    day = date.toLocaleDateString([], {
      weekday: "short",
      month: "short",
      day: "numeric",
      year:
        date.getFullYear() === new Date().getFullYear() ? undefined : "numeric",
    });
  }
  return [day, clockTime(date, use24hTimeFormat)];
}

// Show a centered timestamp before a message when the day changed or an
// hour passed since the previous one, like Messages does
export function needsTimestamp(previous?: Date | null, current?: Date | null) {
  if (!current) {
    return false;
  }
  if (!previous) {
    return true;
  }
  return (
    startOfDay(previous) !== startOfDay(current) ||
    current.getTime() - previous.getTime() > 60 * 60 * 1000
  );
}
